/* src/app/global/components/global-settings/global-settings.component.scss */
button {
  text-transform: uppercase;
  z-index: 10000;
}
/*# sourceMappingURL=global-settings.component.css.map */
